import {TItemId} from 'src/constants';
import {EDocumentType, TECH_PARTNER_DOCUMENT_TYPES} from 'src/containers/User';

import {useGetTenantLeadDetailsQuery} from './api';

export const useLeadTechPartnerCheck = ({tenantId}: {tenantId?: TItemId} = {}) => {
  const {data: leadDetails, isLoading} = useGetTenantLeadDetailsQuery(tenantId);

  return {
    isTechPartner: TECH_PARTNER_DOCUMENT_TYPES.includes(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      leadDetails?.documentType as any as EDocumentType,
    ),
    isTechPartnerLoading: isLoading,
  };
};
